// axios
import axios from 'axios'

export default axios.create({
  //   baseURL: 'https://learn-api.intellectualpoint.com/v1/'
  baseURL: 'http://localhost:49538/v1/'
})
